import React, { useMemo } from 'react';
import { useParams } from 'umi';

export default function MetricDetailCardService(props: any) {
  const {
    style,
    className,
    children,
    data,
    ...resetProps
  } = props || {};

  const { metric } = useParams<{ metric: string; }>();
  const { metricConfig } = data || {};
  const metricKeys = Object.keys(metricConfig || {})?.toString();

  // 获取当前同类型指标
  const metricGroupList = useMemo(() => {
    const currentMetricConfig = metricConfig?.[metric] || {};
    const currentMetricGroup = currentMetricConfig.group;
    const groupList = Object.keys(metricConfig || {})?.filter((key) => {
      const item = metricConfig[key] || {};
      return currentMetricGroup && item.group === currentMetricGroup;
    })?.map(key => metricConfig[key]);

    return groupList?.sort((a, b) => a.group_sort - b.group_sort);
  }, [metricKeys, metric]);

  return (
    <div className={className} style={style}>
      {React.Children.map(children, (child: any) =>
        React.cloneElement(child, {
          data,
          metricGroupList,
          ...resetProps,
        }),
      )}
    </div>
  );
}
